import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsScrolled(scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = 70;
      const targetPosition = section.offsetTop - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <img src="/paradise-logo.svg" alt="Paradise Formaturas Logo" className="logo-img" />
          </div>
          
          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <a href="#inicio" className="nav-link neon-text" onClick={() => scrollToSection('inicio')}>Início</a>
            </li>
            <li className="nav-item">
              <a href="#quem-somos" className="nav-link neon-text" onClick={() => scrollToSection('quem-somos')}>Quem Somos</a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link neon-text" target="_blank" rel="noopener">Portfólio</a>
            </li>
            <li className="nav-item">
              <a href="#feedback" className="nav-link neon-text" onClick={() => scrollToSection('feedback')}>Feedback</a>
            </li>
            <li className="nav-item">
              <a href="https://api.whatsapp.com/send?phone=5575999481498&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20a%20Paradise%20Formaturas." className="nav-link neon-text" target="_blank" rel="noopener">Contato</a>
            </li>
          </ul>
          
          <a href="http://www.eFormei.com.br/sistema" className="area-formando-btn" target="_blank" rel="noopener">
            <i className="fas fa-graduation-cap"></i>
            ÁREA DO FORMANDO
          </a>

          <a href="http://www.eFormei.com.br/sistema" className="area-formando-btn-mobile" target="_blank" rel="noopener">
            <i className="fas fa-graduation-cap"></i>
            ÁREA DO FORMANDO
          </a>
          
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;